import { legacyAccountAPI } from '../apis/authApi/authAPI';
import type { UserInfoViewModelApp } from '../apis/authApi/types';
import { getImageLink } from '../utils/formatImageLink';
import type { getTenants } from './organizations';

export const getLegacyUserTenants = async (): ReturnType<typeof getTenants> => {
  const user = await legacyAccountAPI.performExtra<UserInfoViewModelApp>({
    method: 'GET',
    extraResource: 'info/app',
  });
  if (!user || !user.organizationID || !user.organizationName) {
    return {
      error: {
        status: 'error',
        error: {
          httpStatus: 400,
          code: 'BAD_REQUEST',
          details: {
            issues: {
              paramsResult: null,
              headersResult: null,
              queryResult: null,
              bodyResult: null,
            },
          },
        },
      },
      response: {} as Response,
    };
  }

  return {
    data: {
      status: 'success',
      data: [
        {
          id: user.organizationID,
          name: user.organizationName,
          logoUrl: user.organizationLogo
            ? getImageLink({ imageName: user.organizationLogo })
            : null,
          websiteUrl: user.organizationWebsite,
        },
      ],
      metadata: {
        pagination: {
          totalCount: 1,
          offset: 0,
          limit: 1,
        },
      },
    },
    response: {} as Response,
  };
};
